module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAADICAYAAAAgGSuPAAAApklEQVRYR+2XQQrCMBBFX+i2XkA8hT1IvYneRG/iORS67Q16ji9TbZlmJ7gRfiCLfEIyPCYz+YVqSOpL1iS1wFiLV+CyipKOwBNoZlFSAzyALtaLeAZuy/lF0iEOB3ZZvAOnHEXsVB2rxYqIgRjISsDJ4GRwMkTrce/YvgQDcWVwZXBl8I/aFuNN4AcdYf9xeuH25rkxjNncTcCQ53e3+6KE71/QvQCMfxgJaXd81QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/boder.png
// module id = 3sVt
// module chunks = 1